import Content from './content';
import { useTranslation } from '@CS/hooks';
import CSS from './RequestError.module.css';
import { type PopupProps, Popup } from '@CS/components/Popups';

type RequestErrorProps = PopupProps & {
  info?: {
    message?: string;
    error?: string;
    code?: number;
  };
};

export const RequestError = ({ info = {}, ...props }: RequestErrorProps) => {
  const { title, retry } = useTranslation(Content);
  const { code, error, message } = info;

  return (
    <Popup {...props}>
      <div className={CSS.descriptionContainer}>
        <h2>{(!code && error) || title}</h2>

        {(code || message) && (
          <div className={CSS.errorDescription}>
            {code && (
              <strong>
                {code && `${code}${error ? ': ' : ''}`}
                {error}
              </strong>
            )}

            <span>{message}</span>
          </div>
        )}

        <em>{retry}</em>
      </div>
    </Popup>
  );
};
